import DataTable from "react-data-table-component"
import { customThemeTable } from './SxOneTable'

const OneTable = ({ columns, data, dobleClickCallback, extraCallbackParams, icone, ...rest }) => {
    let pageSize = document.body.clientHeight - 160

    return (
        <DataTable
            columns={columns}
            data={data}
            customStyles={customThemeTable}
            fixedHeader
            fixedHeaderScrollHeight={`${pageSize}px`}
            striped
            noDataComponent={<div style={{ height: '50px', fontSize: '30px' }}>Não há dados para exibição</div>}
            onRowDoubleClicked={(row, event) => dobleClickCallback(extraCallbackParams ? row : row.id)}
            {...rest}
        />
    )
}

export default OneTable
